<template>
  <card-list class="card-list--project"
    :text-color="textColor"
    :accent-color="accentColor"
    :button-color="cardColor"
    :button-text-color="cardTextColor"
    :columns="columns"
    :items="filtered">

    <template v-slot:filters>
      <div class="filter">
        <div class="filter__label">Tags</div>
        <div
          v-for="category in categoryList"
          v-bind:key="category"
          @click="onCategoryClick(category)"
          :class="{ 'filter__option': true, active: activeCategories.indexOf(category) > -1 }"
        >{{ category === '*' ? 'all' : category }}</div>
      </div>
      <div class="filter">
        <div class="filter__label">Status</div>
        <div
          v-for="status in statusList"
          v-bind:key="status"
          @click="activeStatus = status"
          :class="{ 'filter__option': true, active: activeStatus === status }"
        >{{ status === '*' ? 'all' : status }}</div>
      </div>
    </template>

    <template v-slot:card="slotProps">
      <project-card
        :horizontal="horizontal"
        :card-color="cardColor"
        :text-color="cardTextColor"
        :accent-color="accentColor"
        :border-color="borderColor"
        :placeholder-image="placeholderImage"
        :project="slotProps.item" />
    </template>
  </card-list>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

import CardList from '@/components/CardList'
import ProjectCard from '@/components/ProjectCard'

export default {

  name: 'project-card-list',

  components: {
    'card-list': CardList,
    'project-card': ProjectCard
  },

  props: {
    columns: {
      type: Number
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    cardColor: {
      type: String,
      default: '#ffffff'
    },
    textColor: {
      type: String,
      default: '#ffffff'
    },
    cardTextColor: {
      type: String,
      default: '#ffffff'
    },
    accentColor: {
      type: String,
      default: '#ffffff'
    },
    borderColor: {
      type: String,
      default: '#ffffff'
    },
    placeholderImage: {
      type: String
    },
    source: {
      type: [String, Array],
      required: true
    }
  },

  data () {
    return {
      projects: [],
      activeCategories: ['*'],
      activeStatus: '*'
    }
  },

  mounted () {
    this.fetchProjects()
  },

  computed: {
    ...mapState(['$projects']),

    categoryList () {
      let categories = ['*']
      this.projects.forEach(item => {
        if (item.hasOwnProperty('category')) {
          if (
            typeof item['category'] === 'object' &&
            Array.isArray(item['category'])
          ) {
            categories.push(...item['category'])
          } else if (typeof item['category'] === 'string') {
            categories.push(item['category'])
          }
        }
      })
      return [...new Set(categories)]
    },

    statusList () {
      let status = ['*']
      this.projects.forEach(item => {
        if (item.hasOwnProperty('status')) {
          if (
            typeof item['status'] === 'object' &&
            Array.isArray(item['status'])
          ) {
            status.push(...item['status'])
          } else if (typeof item['status'] === 'string') {
            status.push(item['status'])
          }
        }
      })
      return [...new Set(status)]
    },

    filtered () {
      return this.projects.filter(item => {
        if (item.hasOwnProperty('category')) {
          if (!(
            this.activeCategories.indexOf('*') > -1 ||
            this.activeCategories.every(category => item['category'].indexOf(category) > -1)
          )) {
            return false
          }
        } else {
          console.error(
            `Seems like property you passed down category doesn't exist on object ! `
          )
          return false
        }
        if (item.hasOwnProperty('status')) {
          if (!(
            this.activeStatus === '*' ||
            item['status'] === this.activeStatus
          )) {
            return false
          }
        } else {
          console.error(
            `Seems like property you passed down status doesn't exist on object ! `
          )
          return false
        }
        return true
      })
    }
  },

  methods: {
    ...mapMutations(['increase$loading', 'decrease$loading']),

    fetchProjects () {
      if (typeof this.source === 'string') {
        /* this.increase$loading()
        fetch(this.source)
          .then(stream => stream.json())
          .then(data => (this.projects = data
            .sort((a, b) => new Date(b.start || 0) - new Date(a.start || 0))))
          .then(() => { this.decrease$loading() })
          .catch(error => { this.decrease$loading(); console.error(error) }) */
        this.projects = this.$projects.sort((a, b) => new Date(b.start || 0) - new Date(a.start || 0))
      } else {
        this.projects = this.source
          .sort((a, b) => new Date(b.start || 0) - new Date(a.start || 0))
      }
    },

    onCategoryClick (filter) {
      if (filter === '*') {
        this.activeCategories = ['*']
      } else {
        let index = this.activeCategories.indexOf(filter)
        if (index > -1) {
          this.activeCategories.splice(index, 1)
          if (this.activeCategories.length === 0) {
            this.activeCategories = ['*']
          }
        } else {
          if (this.activeCategories.length === 1 && this.activeCategories[0] === '*') {
            this.activeCategories = [filter]
          } else {
            this.activeCategories.push(filter)
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.filter {
  display: flex;
  align-items: center;
  text-transform: uppercase;

  &:nth-child(2) {
    justify-content: flex-end;
  }

  &__label {
    flex: 1;
    margin-right: 1rem;
    font-weight: 700;

    @media (max-width: 576px) {
      flex: 1;
      width: 100%;
      margin: 0.5rem 0;
      text-align: left;
    }
  }

  &__option {
    background-color: var(--button-color);
    color: var(--button-text-color);
    cursor: pointer;
    font-weight: 400;
    font-size: 0.9rem;
    text-transform: uppercase;
    margin: 0 5px 0 5px;
    overflow: visible;
    padding: 0.3rem 1rem;
    position: relative;
    display: inline-block;
    -webkit-transition: color .3s ease-in-out, background-color .3s ease-in-out, border-color .3s ease-in-out;
    transition: color .3s ease-in-out, background-color .3s ease-in-out, border-color .3s ease-in-out;
    flex-grow: 0;
    white-space: nowrap;

    &:first-child {
      margin-left: 0;
    }

    &.active {
      background-color: var(--accent-color);
      color: var(--text-color);
      cursor: default;
    }

    @media (max-width: 576px) {
      -webkit-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      width: 100%;
      text-align: center;
      margin: 0.5rem 0;
    }
  }

  @media (max-width: 1200px) {
    flex-direction: row;
    flex: 1;
    width: 100%;
    margin: 0.5rem 0;
  }

  @media (max-width: 576px) {
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectCardList.vue